/**
 * 결재 문서 상태값 상수
 * - C++ 코드의 enum과 동일한 값 사용
 */
export const DOCUMENT_STATE = {
  /** 진행 중 */
  ING: 0,
  /** 결재 대기 */
  WAITSIGN: 1,
  /** 결재 중 */
  SIGNING: 2,
  /** 결재 완료 */
  SIGNED: 3,
  /** 반려 */
  RETURN: 4,
  /** 삭제 */
  DEL: 5,
  /** 반려(수정) - 수정요청 */
  RETURNEDIT: 6,
};
